import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
interface RecoveryRingProps {
  score: number;
  size?: number;
  strokeWidth?: number;
  color?: 'green' | 'red';
  showText?: boolean;
  label?: string;
  delay?: number;
}
export function RecoveryRing({
  score,
  size = 120,
  strokeWidth = 8,
  color = 'green',
  showText = true,
  label = 'RECOVERY',
  delay = 0
}: RecoveryRingProps) {
  const [currentScore, setCurrentScore] = useState(0);
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - score / 100 * circumference;
  const colorHex = color === 'green' ? '#00ff88' : '#ff3355';
  const glowColor = color === 'green' ? 'rgba(0, 255, 136, 0.5)' : 'rgba(255, 51, 85, 0.5)';
  useEffect(() => {
    const timer = setTimeout(() => {
      let start = 0;
      const duration = 1500;
      const increment = score / (duration / 16);
      const animate = () => {
        start += increment;
        if (start < score) {
          setCurrentScore(Math.floor(start));
          requestAnimationFrame(animate);
        } else {
          setCurrentScore(score);
        }
      };
      requestAnimationFrame(animate);
    }, delay * 1000);
    return () => clearTimeout(timer);
  }, [score, delay]);
  return <div className="relative flex flex-col items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-196">
      <svg width={size} height={size} className="transform -rotate-90" data-id="element-197">
        {/* Background circle */}
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="#222222" strokeWidth={strokeWidth} fill="transparent" data-id="element-198" />
        {/* Progress circle */}
        <motion.circle initial={{
        strokeDashoffset: circumference
      }} animate={{
        strokeDashoffset
      }} transition={{
        duration: 1.5,
        delay,
        ease: 'easeOut'
      }} cx={size / 2} cy={size / 2} r={radius} stroke={colorHex} strokeWidth={strokeWidth} fill="transparent" strokeDasharray={circumference} strokeLinecap="round" style={{
        filter: `drop-shadow(0 0 8px ${glowColor})`
      }} data-id="element-199" />
      </svg>

      {showText && <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-200">
          <span className="text-3xl font-bold tracking-tighter" style={{
        color: colorHex
      }} data-id="element-201">
            {currentScore}%
          </span>
          {label && <span className="text-[10px] font-mono tracking-widest text-brand-gray uppercase mt-1" data-id="element-202">
              {label}
            </span>}
        </div>}
    </div>;
}